module.exports = {"title":"Fotos","popover":"Hier kannst du Fotos raufladen, die deine Guardians anschauen können.","addPhotoButton":"Foto hinzufügen +","meta":"Fotos"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/photos.json
// module id = CO9I
// module chunks = 1